<script setup lang="ts">
import LeSelect from "@dsk/components/Form/LeSelect.vue";
import LeGlobe from "@dsk/icons/LeGlobe.vue";

import { config } from "@/config";
import type { LeSelectOption } from "@/types";

const props = defineProps<{
  options: LeSelectOption<string>[];
}>();

const emit = defineEmits<{
  change: [language: string];
}>();

const { language: currentLanguage } = config.app;

const onLanguageChange = (newLanguage: string | undefined) => {
  if (newLanguage === undefined) {
    return;
  }

  emit("change", newLanguage);
};
</script>

<template>
  <LeSelect
    :model-value="currentLanguage"
    :options="props.options"
    width="164px"
    size="small"
    drop-up
    @update:model-value="onLanguageChange($event)"
  >
    <template #icon>
      <LeGlobe role="presentation" />
    </template>
  </LeSelect>
</template>
